import Vue from 'vue'
import VueI18n from 'vue-i18n'
import translations from 'translations' // IMPORTANT : You need to create an alias in your project's webpack.base.conf.js file to import this file !

// Use Lokalise
Vue.use(VueI18n)

// Use the browser language by default
let lang = window.navigator.languages ? window.navigator.languages[0] : null
lang = lang || window.navigator.language || window.navigator.browserLanguage || window.navigator.userLanguage

let shortLang = lang
if (shortLang.indexOf('-') !== -1) {
    shortLang = shortLang.split('-')[0]
}

if (shortLang.indexOf('_') !== -1) {
    shortLang = shortLang.split('_')[0]
}

const i18n = new VueI18n({
    fallbackLocale: 'fr',
    locale: shortLang,
    messages: translations,
    silentTranslationWarn: true
})

export default i18n
